import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ConsentService } from '../../../core/services/consent.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-consent-banner',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './consent-banner.component.html',
    styleUrls: ['./consent-banner.component.scss']
})
export class ConsentBannerComponent implements OnInit, OnDestroy {
    showBanner = false;
    private destroy$ = new Subject<void>();

    constructor(private consentService: ConsentService) { }

    ngOnInit(): void {
        // Show banner only if user hasn't made a decision yet
        this.consentService.consent$
            .pipe(takeUntil(this.destroy$))
            .subscribe(consent => {
                this.showBanner = consent === null;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    acceptConsent(): void {
        this.consentService.setConsent(true);
    }

    declineConsent(): void {
        this.consentService.setConsent(false);
    }
}
